import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {ELEMENT} from '../../../../../incase-domain/elements/base/ElementTypes';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';
import {QuestionElementInteractions} from '../../../../../incase-domain/proptypes/runfile';
import {loadedPresentationSelector} from '../../../../../store/selectors/presentation.selectors';
import {isQuestionRetriable} from '../../../../../util/util';
import {getAttemptsAndRetriable} from '../../../../../incase-domain/utils/retryCount';
import {DEFAULT_NUMBER_OF_RETRIES} from '../../../../../constants';

export function useQuestionRemaining(
    element: IElementQuestionnaire,
    elementInteractions: QuestionElementInteractions
): {
    isRetriable: boolean;
    remainingAttempts: number;
    numberOfAttempts: number;
    emitRemainingTriesToast: () => void;
} {
    const {t} = useTranslation();
    const presentation = useSelector(loadedPresentationSelector);
    const attemptsAndRetriable = getAttemptsAndRetriable(element, presentation);

    const isRetriable: boolean =
        isQuestionRetriable(element, presentation) &&
        (element.singleCorrect || element.haveTryButton || element.type === ELEMENT.SEQUENCE_QUESTION);

    const numberOfAttempts = attemptsAndRetriable?.maxAttempts || DEFAULT_NUMBER_OF_RETRIES;

    const remainingAttempts: number =
        numberOfAttempts - (elementInteractions.retriedAnswers?.length || 0) - (elementInteractions.answered ? 1 : 0);

    function emitRemainingTriesToast(): void {
        if (isRetriable) {
            toast.error(t('retryQuestion.remainingAttempts', {count: remainingAttempts - 1}));
        }
    }

    return {isRetriable, remainingAttempts, numberOfAttempts, emitRemainingTriesToast};
}
